import type { TSemiAutomaticAutoSendOption } from '~/modules/opportunities/automated-email/settings/types';

import {
  DEFAULT_SEMI_AUTOMATIC_AUTO_SEND_DAYS,
  SEMI_AUTOMATIC_AUTO_SEND_DAY_VALUES,
  getSemiAutomaticAutoSendOptions,
} from '~/modules/opportunities/automated-email/settings/config';

export const coerceSelectableSemiAutomaticAutoSendDays = (
  value?: number,
  isLettings: boolean = false
): number => {
  const options: TSemiAutomaticAutoSendOption[] = getSemiAutomaticAutoSendOptions(isLettings);

  const normalized: number =
    value !== undefined && SEMI_AUTOMATIC_AUTO_SEND_DAY_VALUES.has(value)
      ? value
      : DEFAULT_SEMI_AUTOMATIC_AUTO_SEND_DAYS;

  const option: TSemiAutomaticAutoSendOption | undefined = options.find(
    (o: TSemiAutomaticAutoSendOption): boolean => o.days === normalized
  );

  return option?.disabled ? 0 : normalized;
};
